import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { PublicSharePage } from '@/features/files';

function PublicShareRoute(): ReactNode {
  const { token } = Route.useParams();
  return <PublicSharePage token={token} />;
}

export const Route = createFileRoute('/s/$token')({
  component: PublicShareRoute,
});
